const updateServices = {
  toastr: 'Servicio actualizado con éxito',
  toastrError: 'Servicio ya registrado',
  toastrError1: 'Nombre ya registrado'
};

export default updateServices;
